var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardContainer',[_c('MembersGrid',{attrs:{"LSources":_vm.leadSources,"permissions":_vm.lPermissions}}),_c('AddTeamMember',{attrs:{"LSources":_vm.leadSources,"permissions":_vm.lPermissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }